import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root' 
})
export class Global {
  isAuthenticated: boolean = false;
  signalRHub: any;
  signalR: any;
  colorTheme: string = 'success';
  timeoutForAlert: number = 5000;
  //timeoutForResponseFailer: number = 30000;
}